var _feFlood, _feComposite, _feGaussianBlur, _feOffset, _feComposite2, _linearGradient;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "97.464386mm",
    height: "35.548958mm",
    viewBox: "0 0 97.464383 35.548958",
    id: "svg5",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7535"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#00ff00",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop7531"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#0001ff",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop7533"
  })), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter5613",
    x: -0.12211752,
    y: -0.10297129,
    width: 1.3233267,
    height: 1.2859721
  }, _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.639216,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    id: "feFlood5603"
  })), _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1",
    id: "feComposite5605"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    stdDeviation: 1.4,
    result: "blur",
    id: "feGaussianBlur5607"
  })), _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.5,
    dy: 3,
    result: "offset",
    id: "feOffset5609"
  })), _feComposite2 || (_feComposite2 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    operator: "over",
    result: "composite2",
    id: "feComposite5611"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient7535",
    id: "linearGradient7537",
    x1: 28.898819,
    y1: 42.717716,
    x2: 28.194834,
    y2: -0.015008594,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-17.091091,-7.2316497)"
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "42.3333px",
      lineHeight: 1.25,
      fontFamily: "'Footlight MT Pro'",
      InkscapeFontSpecification: "'Footlight MT Pro, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "url(#linearGradient7537)",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      filter: "url(#filter5613)"
    },
    x: -0.52676797,
    y: 29.897482,
    id: "text1513"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1511",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "42.3333px",
      fontFamily: "'Footlight MT Pro'",
      InkscapeFontSpecification: "'Footlight MT Pro, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "url(#linearGradient7537)",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 0.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    x: -0.52676797,
    y: 29.897482
  }, "S")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "14.1111px",
      lineHeight: 1.25,
      fontFamily: "'Footlight MT Pro'",
      InkscapeFontSpecification: "'Footlight MT Pro, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      strokeWidth: 0.264583
    },
    x: 22.319954,
    y: 15.775745,
    id: "text3571"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan3569",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "14.1111px",
      fontFamily: "'Footlight MT Pro'",
      InkscapeFontSpecification: "'Footlight MT Pro, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      strokeWidth: 0.264583
    },
    x: 22.319954,
    y: 15.775745,
    dx: "0 0 0 0 0 0"
  }, "ap", /*#__PURE__*/React.createElement("tspan", {
    style: {
      letterSpacing: "-0.79375px"
    },
    id: "tspan2746"
  }, "o'n"), "uk")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "14.1111px",
      lineHeight: 1.25,
      fontFamily: "'Footlight MT Pro'",
      InkscapeFontSpecification: "'Footlight MT Pro, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      strokeWidth: 0.264583
    },
    x: 22.42178,
    y: 26.349825,
    id: "text5123"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan5121",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "14.1111px",
      fontFamily: "'Footlight MT Pro'",
      InkscapeFontSpecification: "'Footlight MT Pro, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      strokeWidth: 0.264583
    },
    x: 22.42178,
    y: 26.349825
  }, "ustainability")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bf63c003165018208d919fe0e3a842f2.svg";
export { ForwardRef as ReactComponent };